
var logout_btn = document.getElementById('logOutBtn');
if (logout_btn !== null) {
	logout_btn.onclick = function() {
		document.getElementById('logOut').submit();
	}
}

var logout_btn_resp = document.getElementById('logOutBtnResp');
if (logout_btn_resp !== null) {
	logout_btn_resp.onclick = function() {
		document.getElementById('logOut').submit();
	}
}

// Toggle mobile menu
var hamburger_icon = document.getElementById('hamburger-icon');
if (hamburger_icon !== null) {
	hamburger_icon.onclick = function() {
		var header_nav = document.getElementsByClassName('header--nav');
		if(header_nav[0].classList.contains('d-none')) {
			header_nav[0].classList.remove('d-none');
		} else {
			header_nav[0].classList.add('d-none');
		}
	}
}
var floating_menu = document.getElementsByClassName('header');
var btnScrollTop = document.getElementById('btnScrollTop');
if (btnScrollTop !== null) {
	btnScrollTop.onclick = function() {
		scrollToItem(document.body, 0);
	}
}


// Initialize floating menu on load and on scroll
if (document.getElementsByClassName('header').length > 0) {
	set_floating_menu(window.scrollY);
	window.onscroll = function() {
		set_floating_menu(this.scrollY);
	}
}

// Set the Onpage scroll effect for elemts with scroll-to class
body = document.body;

var scroll_to = document.getElementsByClassName('scroll-to');
for (var i = 0, len = scroll_to.length; i < len; i++) {
	scroll_to[i].onclick = function () {
		var active_items = document.getElementsByClassName('scroll-to active');
		for (var j = 0, len = active_items.length; j < len; j++) {
			active_items[j].classList.remove('active');
		}
		this.classList.add('active');
		var data_scroll = this.getAttribute('data-scroll');
		var e = document.getElementById(data_scroll);
		floating_menu_height = 0;
		if (floating_menu !== null) {
			floating_menu_height = floating_menu[0].offsetHeight;
		}
		scrollToItem(e, floating_menu[0].offsetHeight);
	}
}

// Returns the actual scroll position of the page
function getPageScroll() {
	var yScroll;

	if (window.pageYOffset) {
		yScroll = window.pageYOffset;
	} else if (document.documentElement && document.documentElement.scrollTop) {
		yScroll = document.documentElement.scrollTop;
	} else if (document.body) {
		yScroll = document.body.scrollTop;
	}
	return yScroll;
}

// Activale floating menu if scrolled over 100 px
function set_floating_menu(scrollTop) {
	if (scrollTop > 100) {
		var active_new = document.getElementsByClassName('header');
		document.body.style.paddingTop  = (active_new[0].offsetHeight)+"px";
		active_new[0].classList.add('floating');
	} else {
		var active_new = document.getElementsByClassName('header');
		document.body.style.paddingTop = "";
		active_new[0].classList.remove('floating');
	}
}

function scrollToItem(item, floating_menu_height) {
    var diff = ((item.offsetTop - floating_menu_height) - window.scrollY) / 30;
    if(!window._lastDiff){
        window._lastDiff = 0;
    }

    if (Math.abs(diff) > 2) {
        window.scrollTo(0, (window.scrollY + diff));
        clearTimeout(window._TO);

        if (diff !== window._lastDiff) {
            window._lastDiff = diff;
            window._TO = setTimeout(scrollToItem, 15, item, floating_menu_height);
        }
    } else {
        window.scrollTo(0, (item.offsetTop - floating_menu_height));
    }
}

// Show alerts
setInterval(function () {
	document.querySelectorAll('.alerts-container .alert').forEach(function(alert) {
		alert.classList.add('d-none');
	});
}, 3000);

function showAlertMessage(message, isError) {
	document.getElementById('alerts-container').classList.remove('d-none');

	if (isError) {
		var errorAlert = document.getElementById('validation-error-alert');
		errorAlert.querySelector('.message').innerHTML = message;
		document.getElementById('alerts-container').classList.remove('d-none');
		errorAlert.classList.remove('d-none');
		errorAlert.classList.add('show');
	} else {
		var successAlert = document.querySelector('.alert-success');
		successAlert.querySelector('.message').innerHTML = message;
		successAlert.classList.remove('d-none');
		successAlert.classList.add('show');
	}
}
window.showAlertMessage = showAlertMessage;

// Move to top
var toTopLink = document.querySelector('.move-to-top');
if (toTopLink != null) {
	toTopLink.addEventListener('click', function () {
		window.scrollTo({top: 0, behavior: 'smooth'});
	});
}



// WEBPACK FOOTER //
// ./resources/assets/js/general.js